export default __webpack_public_path__ + "static/media/sec1.ee59f6e9.png";